import { render } from "./AlphabetList.vue?vue&type=template&id=d13cd012&scoped=true"
import script from "./AlphabetList.vue?vue&type=script&lang=js"
export * from "./AlphabetList.vue?vue&type=script&lang=js"

import "./AlphabetList.vue?vue&type=style&index=0&id=d13cd012&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13cd012"]])

export default __exports__